import { render, staticRenderFns } from "./headFeeNewForm.vue?vue&type=template&id=56325a48&scoped=true"
import script from "./headFeeNewForm.vue?vue&type=script&lang=js"
export * from "./headFeeNewForm.vue?vue&type=script&lang=js"
import style0 from "./headFeeNewForm.vue?vue&type=style&index=0&id=56325a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56325a48",
  null
  
)

export default component.exports